<template>
  <div>
    <BaseTitle :title="$t('content.class_section')" />

    <!-- Class Information -->
    <v-card class="pa-8 mb-6">
      <h3 class="app-section-title">{{ $t('content.class_name') }}</h3>
      <v-row>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('form.schoolyear')">
            <template slot-scope="{ attrs }">
              <v-text-field disabled v-model="form.yearPeriode" v-bind="attrs" :label="$t('form.schoolyear')" />
            </template>
          </form-group>
        </v-col>

        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_level')">
            <template slot-scope="{ attrs }">
              <v-select
                v-model="form.gradeId"
                v-bind="attrs"
                disabled
                item-value="gradeId"
                item-text="name"
                :items="class_level"
                :label="$t('content.class_level')"
              />
            </template>
          </form-group>
        </v-col>

        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_sort')">
            <template slot-scope="{ attrs }">
              <v-text-field v-model="form.name" disabled v-bind="attrs" :label="$t('content.class_sort')" />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('form.status')">
            <template slot-scope="{ attrs }">
              <v-select :items="status" :label="$t('form.status')" v-bind="attrs" disabled v-model="form.status" width="100">
                <template #item="{item}">
                  {{ $t(item.text) }}
                </template>
                <template #selection="{item}">
                  {{ $t(item.text) }}
                </template>
              </v-select>
            </template>
          </form-group>
        </v-col>
      </v-row>
    </v-card>

    <!-- Class Section List -->
    <v-card class="pa-8 mb-6">
      <div class="d-flex align-items-center justify-space-between">
        <h3 class="app-section-title mb-6">{{ $t('content.class_section_list') }}</h3>
      </div>
      <v-data-table :headers="tableHeader" :loading="table.loading" :items="listSection" hide-default-footer class="table-custom">
        <template #item.status="{ item }">
          <strong v-if="item.status" class="green--text font-italic header-content">{{ $t('form.active') }}</strong>
          <strong v-else class="red--text font-italic header-content">{{ $t('form.noactive') }}</strong>
        </template>
        <template #item.actions="{ item }">
          <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUpItem(item)">{{ $t('edit') }} {{ $t('form.status') }}</v-btn>
        </template>
        <template #no-data>{{ $t('data_not_available') }}</template>
      </v-data-table>
    </v-card>
    <!-- Dialog Change Status Class Section -->
    <v-dialog v-model="dialogPopUp" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.modal_school_admin_cs') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col cols="12" md="12">
              <form-group :name="$t('form.status')">
                <template slot-scope="{ attrs }">
                  <v-select :items="status" :label="$t('form.status')" v-bind="attrs" v-model="formInput.status" width="100">
                    <template #item="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #selection="{item}">
                      {{ $t(item.text) }}
                    </template>
                  </v-select>
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="dialogPopUp = false">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" :loading="loading" type="submit" @click="changeStatus">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Button Controls -->
    <div class="d-flex justify-end align-center">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'ViewClassSection',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({
      items: 'SchoolClass/items',
      status: 'Reference/itemStatus',
      years: 'Reference/itemSchoolYears',
      user: 'Auth/user'
    }),
    filteredResources() {
      if (this.search1) {
        return this.form.students.filter(item => {
          return item.fullName.startsWith(this.search1);
        });
      } else {
        return this.form.students;
      }
    },
    tableHeader() {
      return [
        { text: this.$t('content.class_sort'), value: 'classSectionName', width: 180 },
        { text: this.$t('content.number_class'), value: 'numberClass', sortable: false },
        { text: this.$t('content.total_student'), value: 'totalStudent', sortable: false },
        { text: this.$t('content.total_teacher'), value: 'totalTeacher', sortable: false },
        { text: this.$t('form.status'), value: 'status', sortable: false },
        { text: this.$t('table.action'), value: 'actions', width: 180, sortable: false }
      ];
    },
    tableHeader1() {
      return [
        { text: this.$t('table.name'), value: 'fullName' },
        { text: 'NIS', value: 'identityNumber' }
      ];
    }
  },
  data: () => ({
    dialogPopUp: false,
    loading: false,
    search: '',
    search1: '',
    listStudent: [],
    class_level: [],
    formInput: {
      status: '',
      classSectionId: ''
    },
    form: {
      yearPeriode: '',
      gradeId: '',
      name: '',
      status: '',
      schoolId: '',
      students: [],
      courses: []
    },
    listSection: [],
    table: []
  }),
  methods: {
    getData() {
      this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.id).then(res => {
        Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        this.hasLoad = true;
      });
    },
    getDataList() {
      this.$store
        .dispatch('ClassSection/getListClassSectionList', { classId: this.$route.params.id, courseId: this.$route.params.courseId })
        .then(res => {
          this.listSection = res;
        });
    },
    getLevel() {
      this.table.loading = true;
      this.$store
        .dispatch('Reportschool/fetchClassLevel')
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .then(res => (this.class_level = res))
        .finally((this.table.loading = false));
    },
    backToList() {
      this.$router.push({ name: 'ViewSchoolClass' });
    },
    dialogPopUpItem(item) {
      this.dialogPopUp = true;
      this.formInput.status = item.status;
      this.formInput.classSectionId = item.classSectionId;
    },
    changeStatus() {
      this.$store
        .dispatch(`ClassSection/updateStatus`, { status: this.formInput.status, classSectionId: this.formInput.classSectionId })
        .then(data => {
          this.$store.dispatch('general/showSuccessNotification', data);
        })
        .finally(() => {
          this.formInput.status = '';
          this.formInput.classSectionId = '';
          this.dialogPopUp = false;
          this.getDataList();
        });
    }
  },
  created() {
    this.getData();
    this.getDataList();
    this.getLevel();
  }
};
</script>

<style lang="scss" scoped>
.move-listatas {
  &-titleatas {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-contentatas {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 25em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
